import React from "react";
import styled from "styled-components/macro";
import { COLORS, FONTSIZE, FONTWEIGHT } from "helpers/designConstants";
import { useTranslation } from "react-i18next";
import ContactEmailLink from "components/shared/ContactEmailLink";

const ContactInfo = ({ contactInfo }) => {
  const { t } = useTranslation();

  return (
    <CourseContactWrapper>
      <ContactTitle>{t("contact_info_title")}</ContactTitle>
      <ContactLineItem>{contactInfo?.companyName}</ContactLineItem>
      <ContactLineItem>{contactInfo?.name}</ContactLineItem>
      <ContactLineItem>{contactInfo?.phone}</ContactLineItem>
      <ContactLineItem>
        <ContactEmailLink email={contactInfo?.email} />
      </ContactLineItem>
    </CourseContactWrapper>
  );
};

const CourseContactWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${COLORS.text};
  padding: 15px 0;
`;

const ContactTitle = styled.div`
  font-size: ${FONTSIZE.medium};
  font-weight: ${FONTWEIGHT.heavy};
  text-transform: uppercase;
  padding: 5px;
`;

const ContactLineItem = styled.div`
  overflow-wrap: anywhere;
  max-width: 100%;
`;

export default ContactInfo;
